module.exports = __webpack_public_path__ + "images/logo.svg";


//////////////////
// WEBPACK FOOTER
// ./images/logo.svg
// module id = 152
// module chunks = 0